"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.cqaActivityFormatter = exports.systemActivityFormatter = exports.SystemActivityEntityType = exports.SystemActivityActionType = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var ui_common_2 = require("@codametrix/ui-common");
var DocumentStatus = ui_common_2.commonEnums.DocumentStatus, HoldReasonType = ui_common_2.commonEnums.HoldReasonType;
var REVISION_TYPE_MAP = {
    ADD: 'Added',
    DEL: 'Deleted',
    MOD: 'Modified'
};
var SystemActivityActionType;
(function (SystemActivityActionType) {
    SystemActivityActionType["ASSIGN_PROFILE"] = "ASSIGN_PROFILE";
    SystemActivityActionType["CASE_VERSION_UPDATE"] = "CASE_VERSION_UPDATE";
    SystemActivityActionType["LATE_CASE_UPDATE"] = "LATE_CASE_UPDATE";
})(SystemActivityActionType = exports.SystemActivityActionType || (exports.SystemActivityActionType = {}));
var SystemActivityEntityType;
(function (SystemActivityEntityType) {
    SystemActivityEntityType["WORKITEM"] = "WORKITEM";
    SystemActivityEntityType["PROCESS_INSTANCE"] = "PROCESS_INSTANCE";
})(SystemActivityEntityType = exports.SystemActivityEntityType || (exports.SystemActivityEntityType = {}));
var systemActivityFormatter = function (activity) {
    var _a, _b;
    var inner;
    if (activity.action === SystemActivityActionType.ASSIGN_PROFILE &&
        activity.targetEntityType === SystemActivityEntityType.WORKITEM) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: ["This case matched the ", (_a = activity === null || activity === void 0 ? void 0 : activity.metadata) === null || _a === void 0 ? void 0 : _a.profileName, " queue for distribution."] })));
    }
    else if ((activity.action === SystemActivityActionType.CASE_VERSION_UPDATE ||
        activity.action === SystemActivityActionType.LATE_CASE_UPDATE) &&
        activity.targetEntityType === SystemActivityEntityType.PROCESS_INSTANCE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: ["The case version has been updated to ", (_b = activity === null || activity === void 0 ? void 0 : activity.metadata) === null || _b === void 0 ? void 0 : _b.caseVersion, "."] })));
    }
    return ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-item" }, { children: [inner, (0, jsx_runtime_1.jsx)("span", __assign({ className: "activity-timestamp" }, { children: activity.timestamp
                    ? ui_common_1.cmxDateTime.format(activity.timestamp, ui_common_1.cmxDateTime.FORMATS.LONG_DATE_TIME)
                    : 'N/A' }))] })));
};
exports.systemActivityFormatter = systemActivityFormatter;
var cqaActivityFormatter = function (item) {
    var _a;
    var date = new Date(item.revInfo.datetime);
    var datetime = ui_common_1.cmxDateTime.formatDateWithComma(date);
    var titles = [];
    if ('code' in item) {
        var cqaCode = item.code;
        titles = [
            "".concat(REVISION_TYPE_MAP[item.revisionType], " ").concat(cqaCode.entityType, " ").concat(cqaCode.code, " on charge ").concat(cqaCode.transaction.sequenceNumber)
        ];
    }
    if ('codeAssessment' in item) {
        var codeAssessment = item.codeAssessment;
        var parentCode = item.codeAssessment.parentCode;
        titles = [
            "".concat(REVISION_TYPE_MAP[item.revisionType], " assessment").concat(item.revisionType === 'MOD' ? ' to ' : ' ').concat(codeAssessment.assessment, " and role ").concat(codeAssessment.role).concat(item.revisionType === 'MOD' ? ' to ' : ' ').concat(parentCode
                ? "for ".concat(parentCode.entityType, " ").concat(parentCode.code, " on charge ").concat((_a = parentCode.transaction) === null || _a === void 0 ? void 0 : _a.sequenceNumber)
                : 'n/a')
        ];
    }
    return !(titles === null || titles === void 0 ? void 0 : titles.length)
        ? false
        : titles.map(function (title, titleIdx) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { marginTop: '5px' } }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "tile-title" }, { children: title })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "cqa-activity-timestamp" }, { children: [datetime ? "".concat(datetime, ", ").concat(date.toLocaleTimeString()) : 'N/A', ' ', "| ".concat(item.revInfo.username)] }))] }), titleIdx)); });
};
exports.cqaActivityFormatter = cqaActivityFormatter;
//# sourceMappingURL=systemactivity-timeline-formatter.js.map